const UpdatePassword = () => <h2>Update Password Page</h2>
export default UpdatePassword